import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import SlotPoster from "@/components/admin/SlotPoster";
import DailyClosing from "@/components/admin/DailyClosing";

export default function ReportsTab() {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [busy, setBusy] = useState("");

  const dl = async (kind, fmt) => {
    setBusy(kind + fmt);
    try {
      const params = { fmt };
      if (kind === "bookings") { if (start) params.start = start; if (end) params.end = end; }
      const r = await api.get(`/admin/export/${kind}`, { params, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = `${kind}.${fmt === "csv" ? "csv" : "xlsx"}`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Export failed"); } finally { setBusy(""); }
  };

  const Card = ({ kind, title, desc }) => (
    <div className="glass rounded-2xl p-5" data-testid={`report-${kind}`}>
      <FileSpreadsheet className="text-purple-300 mb-2" size={22} />
      <h3 className="font-display font-bold">{title}</h3>
      <p className="text-sm text-slate-400 mb-3">{desc}</p>
      <div className="flex gap-2">
        <Button size="sm" onClick={() => dl(kind, "xlsx")} data-testid={`export-${kind}-xlsx`} className="h-9 bg-emerald-600 hover:bg-emerald-500">{busy === kind + "xlsx" ? <Loader2 className="animate-spin" size={14} /> : "Excel"}</Button>
        <Button size="sm" variant="outline" onClick={() => dl(kind, "csv")} data-testid={`export-${kind}-csv`} className="h-9 border-purple-500/30 bg-transparent">CSV</Button>
      </div>
    </div>
  );

  return (
    <div>
      <DailyClosing />
      <div className="glass rounded-2xl p-4 mb-5 flex flex-wrap gap-3 items-end">
        <div><label className="text-xs text-purple-400 font-mono">From (bookings)</label><Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="mt-1 h-10 bg-purple-950/30 border-purple-500/30" /></div>
        <div><label className="text-xs text-purple-400 font-mono">To (bookings)</label><Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="mt-1 h-10 bg-purple-950/30 border-purple-500/30" /></div>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card kind="bookings" title="Bookings Report" desc="All bookings with customer, station, time, amount & status" />
        <Card kind="orders" title="Orders Report" desc="All food & drink orders with items and totals" />
        <Card kind="revenue" title="Revenue Report" desc="Daily gaming + food revenue breakdown" />
        <Card kind="payments" title="Payment Report" desc="PayU / UPI / Cash collections with advance & balance" />
      </div>
      <SlotPoster />
    </div>
  );
}
